import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import usePostRequest from "../../hooks/usePostRequest";
import { API_ENDPOINTS } from "../../constant/_constant";
import { Card, Form } from "react-bootstrap";
import { useState } from "react";
import { toast } from "react-toastify";
import { IconUserCheck } from "@tabler/icons-react";

function ActivateUser({ isOpen, onClose, fetchUsers }) {
  const { postData: ActivateUserStatus } = usePostRequest(
    API_ENDPOINTS.DEACTIVATE_USER
  );

  const onActivateUserSuccess = (response) => {
    toast.success(response.message);
    fetchUsers();
  };

  const onActivateUserError = (error) => {
    toast.success(error.message);
  };

  const handleActivateUser = (user) => {
    ActivateUserStatus(
      {
        status: true,
        username: user?.username,
      },
      onActivateUserSuccess,
      onActivateUserError
    );
    onClose()
  };

  return (
    <Modal centered show={isOpen?.show} onHide={onClose}>
      <Modal.Header className="justify-content-center" closeButton>
          <Modal.Title>Activate Account</Modal.Title>
      </Modal.Header>
    <Modal.Body  className="text-center">
       <span className="trash_avtar bg-green-lt  rounded-circle"> <IconUserCheck stroke={1} /> </span>
       <p>Please Confirm Activate Account</p>
    </Modal.Body> 
      <Modal.Footer className="justify-content-center">
        <Button
          className="btn-warning"
          onClick={() => handleActivateUser(isOpen?.user)}
        >
          Activate Account
        </Button>
        <Button variant="outline-danger" onClick={onClose}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ActivateUser;
